import styles from './Divider.module.css'

export const Divider = () => {
	return <hr className={styles.dotted} />
}
